import { extendTheme } from '@chakra-ui/react';

// Apple-design tokens: https://developer.apple.com/design/ (bg/surface/elevated/text/accent scale)
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: `'Montserrat', sans-serif`,
    body: `'Montserrat', sans-serif`,
  },
  fontSizes: {
    xs: '0.7rem',
    sm: '0.8rem',
    md: '0.875rem',
    lg: '0.95rem',
    xl: '1.05rem',
    '2xl': '1.25rem',
    '3xl': '1.5rem',
    '4xl': '1.875rem',
    '5xl': '2.25rem',
  },
  colors: {
    apple: {
      accent: '#0071E3',
      accentDark: '#2997FF',
    },
  },
  semanticTokens: {
    colors: {
      appleBg: { default: '#FFFFFF', _dark: '#000000' },
      appleSurface: { default: '#F5F5F7', _dark: '#1C1C1E' },
      appleElevated: { default: '#FBFBFD', _dark: '#2C2C2E' },
      appleTextPrimary: { default: '#1D1D1F', _dark: '#F5F5F7' },
      appleTextSecondary: { default: '#86868B', _dark: '#A1A1A6' },
      appleAccent: { default: '#0071E3', _dark: '#2997FF' },
      appleCardBorder: { default: 'rgba(0,0,0,0.06)', _dark: 'rgba(255,255,255,0.08)' },
    },
  },
  radii: {
    sm: '8px',
    md: '12px',
    lg: '18px',
    xl: '24px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.08)',
    md: '0 4px 12px rgba(0,0,0,0.08)',
    lg: '0 8px 30px rgba(0,0,0,0.12)',
    xl: '0 20px 60px rgba(0,0,0,0.15)',
  },
  styles: {
    global: {
      body: {
        bg: 'appleBg',
        color: 'appleTextPrimary',
      },
    },
  },
  components: {
    Card: {
      baseStyle: {
        container: {
          bg: 'appleElevated',
          borderWidth: '1px',
          borderColor: 'appleCardBorder',
          boxShadow: 'sm',
          borderRadius: 'md',
        },
      },
    },
    Button: {
      baseStyle: {
        borderRadius: 'sm',
      },
      defaultProps: {
        colorScheme: 'blue',
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: 'sm',
        },
      },
    },
    Heading: {
      baseStyle: {
        color: 'appleTextPrimary',
      },
    },
  },
});

export default theme;
